import { combineReducers } from 'redux';
import concat from 'lodash/concat';
import { SEARCH_FORM } from 'shared/constants/actionTypes';
import currency from 'shared/constants/json/currency.json';
import mileageUnits from 'shared/constants/json/mileageUnits.json';
import dealers from 'shared/constants/json/dealers.json';
import wheels from 'shared/constants/json/wheels.json';
import states from 'shared/constants/json/states.json';
import busTypes from 'shared/constants/json/busTypes.json';
import truckTypes from 'shared/constants/json/truckTypes.json';
import trailerTypes from 'shared/constants/json/trailerTypes.json';
import technicsTypes from 'shared/constants/json/technicsTypes.json';
import waterTypes from 'shared/constants/json/waterTypes.json';
import customs from 'shared/constants/json/customs.json';
import colors from 'shared/constants/json/colors.json';
import ecoTypes from 'shared/constants/json/ecoTypes.json';
import rent from 'shared/constants/json/rent.json';
import credits from 'shared/constants/json/credit.json';
import ordering from 'shared/constants/json/ordering.json';
import periods from 'shared/constants/json/periods.json';
import capacities from 'shared/constants/json/capacities.json';
import abroadOptions from 'shared/constants/json/abroadOptions.json';
import COUNTRIES from 'shared/constants/json/countries.json';

const SEARCH_FORM_SELECTED = 'SEARCH_FORM__SELECTED__';
const sluggifiedCurrency = currency.map(item => ({ ...item, id: item.slug }));
const IS_MOBILE = __APP__ === 'mobile';

const initialState = {
  selected: {
    make: null,
    makes: null,
    model: null,
    yearTo: null,
    yearFrom: null,
    priceFrom: null,
    priceTo: null,
    prepaid: null,
    monthly: null,
    powerFrom: null,
    powerTo: null,
    capacityFrom: null,
    capacityTo: null,
    mileageFrom: null,
    company: null,
    typeWork: null,
    mileageTo: null,
    engine: null,
    drive: null,
    gearbox: null,
    usedWarranty: null,
    // modification: null,
    category: null,
    colors: [],
    generation: null,
    // description: null,
    location: null,
    // colorFeatures: {},
    // statuses: {},
    options: {},
    ordering: ordering.default[0],
    period: periods[0],
    powerUnit: 1,
    capacityUnit: 1,
    isCrashed: null,
    isNotCleared: null,
    isSaleOnCredit: null,
    isUnderLoan: null,
    isSwap: null,
    isRent: null,
    isNew: null,
    hasNew: null,
    transport: null,
    mileageUnit: mileageUnits[0],
    currency: IS_MOBILE ? sluggifiedCurrency[1] : sluggifiedCurrency[0],
    dealer: null,
    firm: null,
    photos: null, // null - all, 1-with, 0-without
    fromAuction: null,
    engineOrder: null,
    tacts: null,
    transportChild: null,
    ecotype: null,
    unloading: null,
    tonnageFrom: null,
    tonnageTo: null,
    fromDealer: null,

    // technics
    capacityBodyFrom: null,
    capacityBodyTo: null,
    capacityBucketFrom: null,
    capacityBucketTo: null,
    layingWidthFrom: null,
    layingWidthTo: null,
    liftHeightFrom: null,
    liftHeightTo: null,
    admissionHeightFrom: null,
    admissionHeightTo: null,
    armBoomFrom: null,
    armBoomTo: null,
    depBigFrom: null,
    depBigTo: null,
    productivityFrom: null,
    productivityTo: null,

    // dealers fields
    isOfficial: null,
    q: null,
    query: null,
    testDrive: null,
    tradeIn: null,
    credit: null,
    insurance: null,
    accessories: null,
    tags: null,

    // spares fields
    rubric: null,
    sparetype: null,
    isUsed: null,
    isOriginal: null,
    isAnalogue: null,
    abroad: null,
    inStock: null,
    isUnderTheOrder: null,

    // avto
    drivenFrom: null,

    // wheel: wheels[0],
    // state: states[0],
    // credit: credits[0],
    // rent: rent[0],
    // customs: customs[0],
  },
  counts: {},
  results: {},
  data: {
    make: null,
    models: null,
    brandToChose: null,
    // modifications: null,
    // equipments: null,
    generations: null,
    types: null,
    // existingPhotos: [],
    // prices: null,
    // series: null,
    sparetypes: null,
    count: 0,
  },
  vocabulary: {
    makes: null,
    categories: null,
    // colorFeatures: null,
    options: null,
    engines: null,
    drives: null,
    gearboxes: null,
    priceStatuses: null,
    statuses: null,
    locations: null,
    packages: null,
    rubrics: null,
    // avto
    // todo: refactor this logic. We need countries from may be driven cars, but not "europeanCountries".
    europeanCountries: COUNTRIES.filter(
      country => country.isEuropean || country.isUsa || country.includeInDrivenFrom,
    ),
    // Moto
    types: null,
    childrenTransportTypes: {
      avtobus: busTypes,
      gruzovye: truckTypes,
      pritsepy: trailerTypes,
      spetstehnika: technicsTypes,
      'vodnyi-transport': waterTypes,
    },
    engineOrders: null,
    tacts: null,
    // other
    ecotypes: ecoTypes,
    unloadings: null,
    //
    years: Array.from(new Array(50), (val, index) => new Date().getFullYear() - index),
    colors,
    capacities,
    ordering,
    periods,
    credits,
    rent,
    states,
    customs,
    dealers,
    wheels,
    currency,
    mileageUnits,
    abroadOptions,
  },
};

const immutablySetField = (state, field, value) => ({
  ...state,
  [field]: value,
});

const data = (state = initialState.data, action) => {
  switch (action.type) {
    case SEARCH_FORM.DATA_BRAND_TO_CHOSE_SET:
      return immutablySetField(state, 'brandToChose', action.payload);

    case SEARCH_FORM.DATA_MODELS_SET:
      return immutablySetField(state, 'models', action.payload);

    case SEARCH_FORM.DATA_MODIFICATIONS_SET:
      return immutablySetField(state, 'modifications', action.payload);

    case SEARCH_FORM.DATA_PRICES_SET:
      return immutablySetField(state, 'prices', action.payload);

    case SEARCH_FORM.DATA_YEARS_SET:
      return immutablySetField(state, 'years', action.payload);

    case SEARCH_FORM.DATA_GENERATIONS_SET:
      return immutablySetField(state, 'generations', action.payload);

    case SEARCH_FORM.DATA_SERIES_SET:
      return immutablySetField(state, 'series', action.payload);

    case SEARCH_FORM.DATA_DRIVES_SET:
      return immutablySetField(state, 'drives', action.payload);

    case SEARCH_FORM.DATA_GEARBOXES_SET:
      return immutablySetField(state, 'gearboxes', action.payload);

    case SEARCH_FORM.DATA_COUNT_SET:
      return immutablySetField(state, 'count', action.payload);

    case SEARCH_FORM.DATA_MAKES_COUNTER_SET:
      return immutablySetField(state, 'makesCounter', action.payload);

    case SEARCH_FORM.DATA_SPARETYPES_SET:
      return immutablySetField(state, 'sparetypes', action.payload);

    case SEARCH_FORM.RESET_ALL: {
      return {
        ...state,
        ...initialState.data,
      };
    }

    default:
      return state;
  }
};

const vocabulary = (state = initialState.vocabulary, action) => {
  switch (action.type) {
    case SEARCH_FORM.VOCABULARY_SET: {
      return { ...state, ...action.payload };
    }

    case SEARCH_FORM.RESET_ALL: {
      return {
        ...state,
        ...initialState.vocabulary,
      };
    }

    default:
      return state;
  }
};

const results = (state = initialState.results, action) => {
  switch (action.type) {
    case SEARCH_FORM.RESULTS_SET: {
      return { ...state, ...action.payload };
    }

    default:
      return state;
  }
};

const counts = (state = initialState.counts, action) => {
  switch (action.type) {
    case SEARCH_FORM.COUNTS_SET: {
      return { ...state, ...action.payload };
    }

    default:
      return state;
  }
};

const selected = (state = initialState.selected, action) => {
  switch (action.type) {
    case SEARCH_FORM.CLEAR: {
      const { isNew, transport, fromDealer } = state;
      return { ...state, ...initialState.selected, isNew, transport, fromDealer };
    }

    case SEARCH_FORM.RESET_ALL: {
      return {
        ...state,
        ...initialState.selected,
      };
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__MAKE}`: {
      return immutablySetField(state, 'make', action.payload);
    }
    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__MAKES}`: {
      return immutablySetField(state, 'makes', action.payload);
    }
    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__MODEL}`: {
      return immutablySetField(state, 'model', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__YEAR_FROM}`: {
      return immutablySetField(state, 'yearFrom', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__YEAR_TO}`: {
      return immutablySetField(state, 'yearTo', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__CAPACITY_BODY_FROM}`: {
      return immutablySetField(state, 'capacityBodyFrom', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__CAPACITY_BODY_TO}`: {
      return immutablySetField(state, 'capacityBodyTo', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__CAPACITY_BUCKET_FROM}`: {
      return immutablySetField(state, 'capacityBucketFrom', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__CAPACITY_BUCKET_TO}`: {
      return immutablySetField(state, 'capacityBucketTo', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__LAYING_WIDTH_FROM}`: {
      return immutablySetField(state, 'layingWidthFrom', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__LAYING_WIDTH_TO}`: {
      return immutablySetField(state, 'layingWidthTo', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__LIFT_HEIGHT_FROM}`: {
      return immutablySetField(state, 'liftHeightFrom', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__LIFT_HEIGHT_TO}`: {
      return immutablySetField(state, 'liftHeightTo', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__ADMISSION_HEIGHT_FROM}`: {
      return immutablySetField(state, 'admissionHeightFrom', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__ADMISSION_HEIGHT_TO}`: {
      return immutablySetField(state, 'admissionHeightTo', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__ARM_BOOM_FROM}`: {
      return immutablySetField(state, 'armBoomFrom', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__ARM_BOOM_TO}`: {
      return immutablySetField(state, 'armBoomTo', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__DEP_BIG_FROM}`: {
      return immutablySetField(state, 'depBigFrom', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__DEP_BIG_TO}`: {
      return immutablySetField(state, 'depBigTo', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__PRODUCTIVITY_FROM}`: {
      return immutablySetField(state, 'productivityFrom', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__PRODUCTIVITY_TO}`: {
      return immutablySetField(state, 'productivityTo', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__TONNAGE_FROM}`: {
      return immutablySetField(state, 'tonnageFrom', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__TONNAGE_TO}`: {
      return immutablySetField(state, 'tonnageTo', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__CAPACITY_TO}`: {
      return immutablySetField(state, 'capacityTo', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__CAPACITY_FROM}`: {
      return immutablySetField(state, 'capacityFrom', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__CAPACITY_UNIT}`: {
      return immutablySetField(state, 'capacityUnit', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__POWER_UNIT}`: {
      return immutablySetField(state, 'powerUnit', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__GENERATION}`: {
      return immutablySetField(state, 'generation', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__SERIES}`: {
      return immutablySetField(state, 'series', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__BODY}`: {
      return immutablySetField(state, 'body', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__MILEAGE_UNIT}`: {
      return immutablySetField(state, 'mileageUnit', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__CATEGORY}`: {
      return immutablySetField(state, 'category', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__CURRENCY}`: {
      return immutablySetField(state, 'currency', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__ENGINE}`: {
      return immutablySetField(state, 'engine', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__DRIVE}`: {
      return immutablySetField(state, 'drive', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__GEARBOX}`: {
      return immutablySetField(state, 'gearbox', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__MODIFICATION}`: {
      return immutablySetField(state, 'modification', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__EQUIPMENT}`: {
      return immutablySetField(state, 'equipment', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__COLOR}`: {
      return immutablySetField(state, 'color', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__LOCATION}`: {
      return immutablySetField(state, 'location', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__DEALER}`: {
      return immutablySetField(state, 'dealer', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__FIRM}`: {
      return immutablySetField(state, 'firm', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__IS_RENT}`: {
      return immutablySetField(state, 'isRent', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__IS_SWAP}`: {
      return immutablySetField(state, 'isSwap', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__IS_CRASHED}`: {
      return immutablySetField(state, 'isCrashed', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__IS_NOT_CLEARED}`: {
      return immutablySetField(state, 'isNotCleared', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__IS_UNDER_LOAN}`: {
      return immutablySetField(state, 'isUnderLoan', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__IS_SALE_ON_CREDIT}`: {
      return immutablySetField(state, 'isSaleOnCredit', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__TRANSPORT}`: {
      return immutablySetField(state, 'transport', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__IS_NEW}`: {
      return immutablySetField(state, 'isNew', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__FROM_DEALER}`: {
      return immutablySetField(state, 'fromDealer', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__HAS_NEW}`: {
      return immutablySetField(state, 'hasNew', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__IS_USED}`: {
      return immutablySetField(state, 'isUsed', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__TAGS}`: {
      return immutablySetField(state, 'tags', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__IS_ORIGINAL}`: {
      return immutablySetField(state, 'isOriginal', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__IS_ANALOGUE}`: {
      return immutablySetField(state, 'isAnalogue', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__ABROAD}`: {
      return immutablySetField(state, 'abroad', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__ECOTYPE}`: {
      return immutablySetField(state, 'ecotype', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__IN_STOCK}`: {
      return immutablySetField(state, 'inStock', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__IS_UNDER_THE_ORDER}`: {
      return immutablySetField(state, 'isUnderTheOrder', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__FROM_AUCTION}`: {
      return immutablySetField(state, 'fromAuction', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__PHOTOS}`: {
      return immutablySetField(state, 'photos', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__ENGINE_ORDER}`: {
      return immutablySetField(state, 'engineOrder', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__TACTS}`: {
      return immutablySetField(state, 'tacts', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__TRANSPORT_CHILD}`: {
      return immutablySetField(state, 'transportChild', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__IS_PHOTOS}`: {
      return immutablySetField(state, 'photos', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__ORDERING}`: {
      return immutablySetField(state, 'ordering', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__PERIOD}`: {
      return immutablySetField(state, 'period', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__UNLOADING}`: {
      return immutablySetField(state, 'unloading', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__RUBRIC}`: {
      return immutablySetField(state, 'rubric', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__SPARETYPE}`: {
      return immutablySetField(state, 'sparetype', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__DRIVEN_FROM}`: {
      return immutablySetField(state, 'drivenFrom', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__OPTIONS}`: {
      const newOptions = { ...state.options };

      Object.keys(action.payload).forEach(key => {
        // Probably should write that in an immutable way
        delete newOptions[key];
        if (action.payload[key]) {
          newOptions[key] = action.payload[key];
        }
      });

      return {
        ...state,
        options: newOptions,
      };
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.CLEAR__OPTIONS}`: {
      return immutablySetField(state, 'options', initialState.selected.options);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__MILEAGE_FROM}`: {
      return {
        ...state,
        mileageFrom: parseInt(action.payload, 10) || null,
      };
    }
    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__COMPANY}`: {
      return {
        ...state,
        company: action.payload || null,
      };
    }
    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__TYPE_WORK}`: {
      return {
        ...state,
        typeWork: action.payload || null,
      };
    }
    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__MILEAGE_TO}`: {
      return {
        ...state,
        mileageTo: parseInt(action.payload, 10) || null,
      };
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__PRICE_FROM}`: {
      return {
        ...state,
        priceFrom: parseInt(action.payload, 10) || null,
      };
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__MONTHLY}`: {
      return {
        ...state,
        monthly: parseInt(action.payload, 10) || null,
      };
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__PREPAID}`: {
      return {
        ...state,
        prepaid: parseInt(action.payload, 10) || null,
      };
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__PRICE_TO}`: {
      return {
        ...state,
        priceTo: parseInt(action.payload, 10) || null,
      };
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__POWER_TO}`: {
      return {
        ...state,
        powerTo: parseInt(action.payload, 10) || null,
      };
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__POWER_FROM}`: {
      return {
        ...state,
        powerFrom: parseInt(action.payload, 10) || null,
      };
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__COLORS}`: {
      const Сolors = concat(action.payload).map(item => parseInt(item, 10));

      return {
        ...state,
        colors: Сolors,
      };
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.TOGGLE__COLORS}`: {
      const { colors: Сolors } = state;

      const index = colors.indexOf(action.payload);
      if (index !== -1) {
        Сolors.splice(index, 1);
      } else {
        Сolors.push(action.payload);
      }

      return {
        ...state,
        colors: Сolors,
      };
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.TOGGLE__STATUSES}`: {
      const { statuses } = state;

      return {
        ...state,
        statuses: { ...statuses, [action.payload]: !statuses[action.payload] },
      };
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.TOGGLE__PRICE_STATUSES}`: {
      const { priceStatuses } = state;

      return {
        ...state,
        priceStatuses: { ...priceStatuses, [action.payload]: !priceStatuses[action.payload] },
      };
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__IS_OFFICIAL}`: {
      return immutablySetField(state, 'isOfficial', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__Q}`: {
      return immutablySetField(state, 'q', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__QUERY}`: {
      return immutablySetField(state, 'query', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__TEST_DRIVE}`: {
      return immutablySetField(state, 'testDrive', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__TRADE_IN}`: {
      return immutablySetField(state, 'tradeIn', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__CREDIT}`: {
      return immutablySetField(state, 'credit', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__INSURANCE}`: {
      return immutablySetField(state, 'insurance', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__ACCESSORIES}`: {
      return immutablySetField(state, 'accessories', action.payload);
    }

    case `${SEARCH_FORM_SELECTED}${SEARCH_FORM.SELECTED.SET__USED_WARRANTY}`: {
      return immutablySetField(state, 'usedWarranty', action.payload);
    }

    default:
      return state;
  }
};

export default combineReducers({
  selected,
  data,
  results,
  counts,
  vocabulary,
});



// WEBPACK FOOTER //
// ./src/shared/reducers/searchForm.js